import { type QueueState } from "./state";

export const initialState: QueueState = {
  queue: [],
  page: 1,
  pageSize: 10,
  totalItems: 0,
  totalPages: 0,
  statusCounts: { undeliverable: 0, rejected: 0 },
  listRequestId: null,
  isPending: false,
  isRejected: false,
  errorMessage: "",
  openCase: null,
  isLoadingCase: false,
  addresses: [],
  geoCatalog: [],
  isSavingAddress: false,
  logs: [],
  isLoadingLogs: false,
  isLogging: false,
  isActing: false,
  actionError: "",
};
